import { useAppSelector } from "@/hooks/types";
import { getResumes } from "@/store/resume/selectors";
import { Resume } from "@/types/resume";

interface AdminResumeSelectorProps {
    selectedResumeId: string | null;
    onResumeSelect: (resumeId: string | null) => void;
}

export const AdminResumeSelector = ({
    selectedResumeId,
    onResumeSelect,
}: AdminResumeSelectorProps) => {
    const resumes = useAppSelector(getResumes);

    const selectedResume = resumes.find(
        resume => resume.id === selectedResumeId,
    );

    return (
        <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
                Select Resume *
            </label>
            <select
                value={selectedResumeId || ""}
                onChange={e => onResumeSelect(e.target.value || null)}
                className="w-full rounded-lg border border-gray-300 p-3 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
            >
                <option value="">Select a resume...</option>
                {resumes.map((resume: Resume) => (
                    <option
                        key={resume.id}
                        value={resume.id}
                    >
                        {resume.name} (
                        {new Date(resume.updatedAt).toLocaleDateString()})
                    </option>
                ))}
            </select>
            {selectedResume && (
                <div className="mt-2 rounded-lg bg-gray-50 p-3 text-xs">
                    <p className="font-medium text-gray-700">
                        Selected Resume:
                    </p>
                    <p className="text-gray-600">{selectedResume.name}</p>
                    <p className="text-gray-500">
                        Last updated:{" "}
                        {new Date(selectedResume.updatedAt).toLocaleString()}
                    </p>
                    <p className="text-gray-500">
                        Sections: {Object.keys(selectedResume.sections).length}
                    </p>
                    <p className="text-gray-500">
                        {selectedResume.userJobId
                            ? `User Job ID: ${selectedResume.userJobId}`
                            : "No user job attached to this resume"}
                    </p>
                </div>
            )}
        </div>
    );
};
